// =============================================================================
// src/features/analytics/analytics-report-library-markup.ts - aba Relatorios.
// Desde 2026-07-28 a aba lista a biblioteca REAL de PDFs da operacao (pastas
// crise/diario/semanal/mensal/campanha do repo atalaia-relatorios), no lugar dos pacotes
// mock + leitor executivo BR-319. "Abrir PDF" abre o arquivo servido de
// public/assets/relatorios/ no visualizador nativo do navegador (nova aba).
// =============================================================================

import { escapeHtml } from '../../app/dom';
import {
  ANALYTICS_REPORT_CATEGORIES,
  analyticsPdfReportsOfCategory,
} from './analytics-report-library-data';
import type { OmarAnalyticsPdfReport, OmarAnalyticsReportCategory } from './analytics-types';

/** Seletor de PDFs por categoria; injetavel para exercitar o estado vazio. */
type AnalyticsPdfReportsSelector = typeof analyticsPdfReportsOfCategory;

/**
 * Renderiza a aba Relatorios: biblioteca de PDFs por categoria.
 * O seletor e PARAMETRO (mesmo padrao de buildAnalyticsInsightsViewMarkup)
 * porque desde 2026-08-31 nenhuma das 5 categorias esta vazia no dado real —
 * sem injecao o ramo do emptyNote viraria codigo morto no teste, embora siga
 * vivo em producao (toda categoria nova nasce vazia).
 * @example buildAnalyticsReportsViewMarkup(() => []) // todas em estado vazio
 */
export function buildAnalyticsReportsViewMarkup(
  pdfReportsOfCategory: AnalyticsPdfReportsSelector = analyticsPdfReportsOfCategory,
): string {
  return `<section class="u-analytics-module" data-analytics-module-view="reports" aria-labelledby="analyticsReportsTitle" hidden>
    <div class="u-analytics-panel u-analytics-report-panel">${analyticsReportLibraryHeadMarkup()}
    ${ANALYTICS_REPORT_CATEGORIES.map((reportCategory) => analyticsReportCategoryMarkup(reportCategory, pdfReportsOfCategory)).join('')}</div>
  </section>`;
}

function analyticsReportLibraryHeadMarkup(): string {
  // "Criar novo" segue DESABILITADO (pedido do usuario 2026-07-26) — era atalho
  // cosmetico; a biblioteca e alimentada pelo repo de relatorios.
  return `<div class="u-analytics-panel-head"><div><span>Relatorios da operacao</span><h2 id="analyticsReportsTitle">Biblioteca de PDFs</h2></div>
    <button type="button" class="u-analytics-ai-filter" disabled title="Disponivel na proxima fase"><i class="ti ti-plus"></i>Criar novo</button></div>`;
}

function analyticsReportCategoryMarkup(
  reportCategory: OmarAnalyticsReportCategory,
  pdfReportsOfCategory: AnalyticsPdfReportsSelector,
): string {
  const categoryReports = pdfReportsOfCategory(reportCategory.categoryName);
  const categoryBody = categoryReports.length > 0
    ? `<div class="u-analytics-report-grid">${categoryReports.map(analyticsPdfReportCardMarkup).join('')}</div>`
    : `<p class="u-analytics-report-empty">${escapeHtml(reportCategory.emptyNote)}</p>`;
  return `<section class="u-analytics-report-category" data-analytics-report-category="${reportCategory.categoryName}">
    <h3 class="u-analytics-report-category-title">${escapeHtml(reportCategory.categoryLabel)}</h3>${categoryBody}
  </section>`;
}

function analyticsPdfReportCardMarkup(pdfReport: OmarAnalyticsPdfReport): string {
  return `<article class="u-analytics-report-card" data-analytics-pdf-report="${pdfReport.pdfReportId}">
    <span>${escapeHtml(pdfReport.reportKindLabel)}</span><h3>${escapeHtml(pdfReport.reportTitle)}</h3>
    <small>Edicao ${escapeHtml(pdfReport.editionLabel)}</small>
    <div><a class="u-analytics-report-open-pdf" href="${escapeHtml(pdfReport.pdfAssetPath)}" target="_blank" rel="noopener"><i class="ti ti-file-type-pdf" aria-hidden="true"></i> Abrir PDF</a></div>
  </article>`;
}
